import React from 'react';
import Services from '../Services/Services';
import Banner from './Banner/Banner';

const Home = () => {
    return (
        <>
            <Banner/>
            <Services/>
        </>
    );
};

export default Home;